import React, { lazy, Suspense } from 'react';

const LazyDbList = lazy(() => import('./DbList'));

const DbList = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => (
  <Suspense fallback={null}>
    <LazyDbList {...props} />
  </Suspense>
);

export default DbList;
